export default __webpack_public_path__ + "static/media/open_eye_icon.b0eae17d.svg";